import React from 'react'
import styled from 'styled-components'
import { MqDesktop, MqTablet, Mono } from 'streamr-ui/css/consts'
import SocialLinks from './SocialLinks'
import useTranslation from '~utils/useTranslation'
import DangerousHtml from '~shared/DangerousHtml'

const Inner = styled.div`
    display: flex;
    margin-top: 1.5rem;

    @media ${MqDesktop} {
        margin-top: 0;
    }
`

const Personage = styled.div`
    flex: 1;
`

const Name = styled.div`
    color: #0c009a;
    font-size: 1.25rem;
    line-height: 2rem;

    @media ${MqTablet} {
        font-size: 1.125rem;
    }

    @media ${MqDesktop} {
        font-size: 1.25rem;
    }
`

const Title = styled.div`
    color: #adadad;
    font-family: ${Mono};
    font-size: 0.75rem;
    letter-spacing: 1px;
    line-height: 1.5rem;
    text-transform: uppercase;

    @media ${MqDesktop} {
        font-size: 0.875rem;
        letter-spacing: 2px;
    }
`

const Desc = styled.div`
    color: #0c009a;
    line-height: 1.5em;
    padding: 1rem 0;

    span {
        font-size: 0.875em;
    }

    @media ${MqTablet} {
        font-size: 0.875rem;
        line-height: 1.375rem;
    }

    @media ${MqDesktop} {
        font-size: 1.125rem;
        line-height: 1.875rem;
        padding: 2rem 0 0;

        span {
            font-size: 1em;
        }
    }
`

const UnstyledBio = ({ className, member, children }) => {
    const { t } = useTranslation()

    return (
        <div className={className} $appearIntersection>
            <Inner>
                <Personage>
                    <Name $appear>{member.name}</Name>
                    <Title $appear>{t(`teamSection.${member.id}.title`)}</Title>
                </Personage>
                <SocialLinks
                    $appearDirection="none"
                    desktop
                    email={member.email}
                    linkedin={member.linkedin}
                    twitter={member.twitter}
                    website={member.website}
                />
            </Inner>
            <DangerousHtml $appear tag={Desc}>
                {t(`teamSection.${member.id}.description`)}
            </DangerousHtml>
            <SocialLinks
                $appearDirection="none"
                mobile
                email={member.email}
                linkedin={member.linkedin}
                twitter={member.twitter}
                website={member.website}
            />
            {children}
        </div>
    )
}

const Bio = styled(UnstyledBio)`
    backface-visibility: hidden;
    font-size: 1rem;
`

export default Bio
